import {
  ChangeEmailRequest,
  PostChangeEmailVerifyOneTimePasscode,
  PostEmailVerification,
  PostFamilyHubEmailVerification,
  PostGenerateOneTimePasscode,
  PostParentLedTeenEmailVerification,
  PostSSOReconciliationEmailVerification,
  PostVerifyOneTimePasscode,
} from '@lyrahealth-inc/shared-app-logic'

import { axiosInstance } from '../axiosInstance'

export function postEmailVerification(data: PostEmailVerification) {
  return axiosInstance.post(`/v1/user/email/verification`, data)
}

export function postSendEmailVerificationLinkForSsoAccountReconciliation(data: PostSSOReconciliationEmailVerification) {
  return axiosInstance.post(`/v1/user/email/sso/resend/account-reconciliation-verification`, data)
}

export function postParentLedTeenEmailVerification(data: PostParentLedTeenEmailVerification) {
  return axiosInstance.post(`/v1/user/email/verification/parent-led-teen`, data)
}

export const changeEmail = (data: ChangeEmailRequest) => {
  return axiosInstance.post(`/v1/user/email/change`, data)
}

export const postChangeEmailGenerateOneTimePasscode = (data: ChangeEmailRequest) => {
  return axiosInstance.post(`/v1/user/email/change/one-time-passcode`, data)
}

export const postChangeEmailVerifyOneTimePasscode = (data: PostChangeEmailVerifyOneTimePasscode) => {
  return axiosInstance.post(`/v1/user/email/change/one-time-passcode/verify`, data)
}

export function postFamilyHubEmailVerification(data: PostFamilyHubEmailVerification) {
  return axiosInstance.post(`/v1/user/email/verification/family-hub`, data)
}

export function postGenerateOneTimePasscode(data: PostGenerateOneTimePasscode) {
  return axiosInstance.post(`v1/user/email/one-time-passcode/`, data)
}

export function postOneTimePasscodeVerification(data: PostVerifyOneTimePasscode) {
  return axiosInstance.post(`v1/user/email/one-time-passcode/verify`, data)
}
